import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Alert,
} from "reactstrap"
import { Copy } from "lucide-react";
import { showToast } from "../../components/Toast";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import images from "../../assets/images"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Breadcrumb"
import {
  getDepartments,
  addDepartment,
  updateDepartment,
  deleteDepartment,
} from "../../store/departments/actions"
import { getScreenHeight } from '../../helpers/screen_height_helper';
import { FilterForm } from './../../components/Table/FilterForm';
import PageLoader from "../../components/Loaders/pageLoader"

class AccessTypesList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      access: [],
      error: '',
      alert: null, 
      modal: false,
      filters: [],
      filteredPermissions: [],
      AccessTypesListColumns: [
        {
          text: "id",
          dataField: "_id",
          sort: true,
          hidden: true,
          formatter: (cellContent, access) => <>{access._id}</>,
        },
        {
          text: "Access Name",
          dataField: "key",
          sort: true,
          formatter: (cellContent, access) => (
            <>
              <p className="text-muted mb-0">{access.label}</p>
            </>
          ),
        },
        {
          text: "Access Key",
          dataField: "key",
          sort: true,
          formatter: (cellContent, access) => (
            <div className="d-flex justify-content-between align-items-center">
              {/* <p className="text-muted mb-0">{access.key}</p> */}
              <p className="text-muted mb-0">{access.key}</p>
              <Copy
                size={20}
                color="#497ea7"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigator.clipboard
                    .writeText(access.key)
                    .then(() => {
                      showToast(
                        "Copied to clipboard",
                        "Address copied to clipboard!",
                      );
                    })
                    .catch(() => {
                      showToast("error", "Failed to copy address.");
                    });
                }}
              />
            </div>
          ),
        },
        {
          text: "Access Role",
          dataField: "key",
          sort: true,
          formatter: (cellContent, access) => (
            <>
              <p className="text-muted mb-0">{access.permissionType.map((type, index) => (
                <span key={index}>{type}{index < access.permissionType.length - 1 ? ', ' : ''}</span>
              ))}</p>
            </>
          ),
        },
        {
          dataField: "menu",
          isDummyField: true,
          editable: false,
          text: "Action",
          formatter: (cellContent, access) => (
            <div className="d-flex gap-3">
              <Link className="text-success" to="#">
                <i
                  className="mdi mdi-pencil font-size-18"
                  id="edittooltip"
                  onClick={() => this.handleAccessClickEdit(access)}
                ></i>
              </Link>
              <Link className="text-danger" to="#">
                <i
                  className="mdi mdi-delete font-size-18"
                  id="deletetooltip"
                  onClick={() => this.handleDeleteAccess(access)}
                ></i>
              </Link>
            </div>
          ),
        },
      ],
    }
    //create/edit access functions
    this.handleAccessClickNew = this.handleAccessClickNew.bind(this)
    this.handleAccessClickEdit = this.handleAccessClickEdit.bind(this)
    this.checkExistingAccess = this.checkExistingAccess.bind(this)
    this.handleValidAccessSubmit = this.handleValidAccessSubmit.bind(this)

    this.toggle = this.toggle.bind(this)
    this.hideAlert = this.hideAlert.bind(this)
  }
  componentDidMount() {
    const { onGetDepartments } = this.props
    onGetDepartments()
    window.addEventListener('load', getScreenHeight);
    window.addEventListener('click', getScreenHeight, { once: true });
    window.addEventListener('resize', getScreenHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('load', getScreenHeight);
    window.removeEventListener('click', getScreenHeight);
    window.removeEventListener('resize', getScreenHeight);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters) {
      this.applyFilters();
    }
  }
  setNoDbFilters = (filters) => {
    console.log('Setting non-DB filters:', filters)
    this.setState({ filters });
  }
  applyFilters = () => {
    console.log('Applying filters:', this.state.filters)
    const { filters } = this.state;
    let result = [...this.props.permissions]; // or whatever your base array is
console.log('Base permissions:', result)
    if (filters?.modules?.length > 0) {
      result = result.filter((item) =>
        filters.modules.includes(item.module)
      );
    }
  if (filters?.roles?.length > 0) {
    result = result.filter((item) =>
      item.permissionType.some(role => filters.roles.includes(role))
    );
  }
console.log('Filtered permissions:', result)
    this.setState({ filteredPermissions: result });
  }
  /**
   * Close/open modal window for creating/editing department name
   */
  toggle = () => this.setState(prevState => ({ modal: !prevState.modal }))
  /**
   * Open modal for creating new department
   */
  handleAccessClickNew = () => {
    this.setState({ access: [], error: "", isEdit: false })
    this.toggle()
  }
  /**
   * Assign data from table to selected access for edit
   * @param {array} access selected access info
   */
  handleAccessClickEdit = access => {
    this.setState({
      access: {
        _id: access._id,
        module: access.module,
        label: access.label,
        key: access.key,
        permissionType: access.permissionType,
      },
      isEdit: true,
      error: ""
    })
    this.toggle()
  }
  /**
   * Check if access is already exists in the table
   * @param {array} newAccess value with new access name
   * @returns true or false
   */
  checkExistingAccess = (newAccess) => {
    const { permissions } = this.props
    return permissions.some(function(el) {
      return el.label === newAccess.label;
    });
  }
  /**
   * Submit form data to backend
   * @param {*} e 
   * @param {array} values 
   */
  handleValidAccessSubmit = (e, values) => {
    const { onAddDepartment, onUpdateDepartment } = this.props
    const { isEdit, access } = this.state
    if (isEdit) {
      const updateAccess = {
        _id: access._id,
        option: 'access',
        module: values.module,
        label: values.label,
        key: values.key,
        permissionType: values.permissionType
      }
      // update access
      if(this.checkExistingAccess(updateAccess) === true) {
        this.setState({ error: "Access already exists." })
      }else{
        onUpdateDepartment(updateAccess)
        this.setState({ error: "" })
        this.toggle()
      }
    } else {
      const newAccess = {
        option: 'access',
        module: values["module"],
        label: values["label"],
        key: values["key"],
        permissionType: values["permissionType"]
      }
      // add new access
      if(this.checkExistingAccess(newAccess) === true) {
        this.setState({ error: "Access already exists." })
      }else{
        onAddDepartment(newAccess)
        this.setState({ error: "" })
        this.toggle()
      }
    }
  }
  /**
   * Call alert before delete
   * @param {array} access 
   */
  handleDeleteAccess = access => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => this.deleteAlert(access._id+'&access')}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        <p className="fw-bold">{access.label}</p> will be deleted from the system!
      </SweetAlert>
    )
    this.setState({ alert: getAlert() })
  }
  /**
   * @returns set state of alert to null
   */
  hideAlert = () => this.setState({ alert: null })
  /**
   * Delete department from database
   * @param {array} access 
   */
  deleteAlert(id) {
    const { onDeleteDepartment } = this.props
    onDeleteDepartment(id)
    this.setState({
      alert: null,
    })
  }

  render() {
    const { SearchBar } = Search
    const { permissions, profileData } = this.props
    const { isEdit, error, access, modal, alert, loading, filteredPermissions, AccessTypesListColumns } = this.state
    const pageOptions = {
      sizePerPage: permissions.length,
      totalSize: permissions.length, // replace later with size(users),
      custom: true,
    }
    const defaultSorted = [
      {
        dataField: "module", // if dataField is not match to any column you defined, it will be ignored.
        order: "asc", // desc or asc
      },
    ]
    const selectRow = {
      mode: "checkbox",
    }
    const moduleOptions = [...new Map(
      permissions
        .sort((a, b) => a.module.localeCompare(b.module))
        .map(({ _id, module }) => [module, { key: module, label: module, icon: "", colorClass: "bg-primary" }])
    ).values()];
    const roleOptions = [...new Set(permissions.flatMap(t => t.permissionType))].map(role => ({ key: role, label: role, icon: "", colorClass: "bg-primary" }));
    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {profileData.length !== 0 && <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>}
        <div className="page-content">
          <MetaTags>
            <title>Access Types List </title>
          </MetaTags>
          <Container fluid>
            {profileData.accType === "Admin" ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title="Admin" breadcrumbItem="Access Types List" />
                <Row id="card-section">
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="_id"
                          columns={AccessTypesListColumns}
                          data={filteredPermissions.length > 0 ? filteredPermissions : permissions}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="_id"
                              columns={AccessTypesListColumns}
                              data={filteredPermissions.length > 0 ? filteredPermissions : permissions}
                              search
                            >
                              {toolkitprops => (
                                <React.Fragment>
                                  <Row className="mb-2">
                                    <Col sm="4">
                                      <div className="search-box ms-2 mb-2 d-inline-block">
                                        <div className="position-relative">
                                          <SearchBar
                                            {...toolkitprops.searchProps}
                                          />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col sm="4" className="d-flex justify-content-center">
                                        <FilterForm 
                                          // page={page}
                                          filterOptions={{ modules: moduleOptions }}
                                          // filterDbOptions={filterDbOptions}
                                          setNoDbFilters={this.setNoDbFilters}
                                        />
                                        <FilterForm 
                                          // page={page}
                                          filterOptions={{ roles: roleOptions }}
                                          // filterDbOptions={filterDbOptions}
                                          setNoDbFilters={this.setNoDbFilters}
                                        />
                                    </Col>
                                    <Col sm="4">
                                      <div className="text-sm-end">
                                        <Button
                                          color="primary"
                                          className="font-16 btn-block btn btn-primary btn-lg"
                                          onClick={this.handleAccessClickNew}
                                        >
                                          <i className="mdi mdi-plus-circle-outline me-1" />
                                          Create New Access Type
                                        </Button>
                                        <Modal
                                          size="lg"
                                          isOpen={modal}
                                          className={this.props.className}
                                          toggle={this.toggle}
                                        >
                                          <ModalHeader
                                            toggle={this.toggle}
                                            tag="h4"
                                          >
                                            {!!isEdit
                                              ? "Edit Access Type"
                                              : "Add Access Type"}
                                          </ModalHeader>
                                          <ModalBody>
                                            {error !== '' &&
                                            error ? (
                                              <Alert color="danger">
                                                {" "}
                                                {error}{" "}
                                              </Alert>
                                            ) : null}
                                            <AvForm onValidSubmit={ this.handleValidAccessSubmit }>
                                              <Row>
                                                <Col md={6}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="key"
                                                      label="Access Type Key"
                                                      type="text"
                                                      errorMessage="Invalid key"
                                                      validate={{
                                                        required: {
                                                          value: true,
                                                        },
                                                      }}
                                                      value={
                                                        access.key || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="label"
                                                      label="Access Type Label"
                                                      type="text"
                                                      errorMessage="Invalid label"
                                                      validate={{
                                                        required: {
                                                          value: true,
                                                        },
                                                      }}
                                                      value={
                                                        access.label || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={6}>
                                                  <FormGroup className='mb-3'>
                                                    <AvField
                                                      type='select'
                                                      name='module'
                                                      className='form-select'
                                                      label='System Module'
                                                      value={access.module || ''}
                                                      errorMessage='Please select the module'
                                                    >
                                                      <option value=''>-//-</option>
                                                      {[...new Set(permissions.map(t => t.module))].map((module, index) => (
                                                        <option key={index} value={module}>{module}</option>
                                                      ))}
                                                    </AvField>
                                                  </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="permissionType"
                                                      label="Permission Role"
                                                      type="select"
                                                      errorMessage="Invalid permission type"
                                                      multiple
                                                      value={
                                                        access.permissionType || []
                                                      }
                                                    >
                                                      <option value="">Select Permission Role</option>
                                                      <option>Sales Manager</option>
                                                      <option>Warehouse Manager</option>
                                                      <option>Logistic Manager</option>
                                                      <option>Purchase Manager</option>
                                                    </AvField>
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  <div className="text-end">
                                                    <button
                                                      type="submit"
                                                      className="btn btn-success save-user"
                                                    >
                                                      {!!isEdit
                                                        ? "Edit Access Type"
                                                        : "Add Access Type"}
                                                    </button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </AvForm>
                                          </ModalBody>
                                        </Modal>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xl="12">
                                      <div className="table-responsive">
                                        <BootstrapTable
                                          {...toolkitprops.baseProps}
                                          {...paginationTableProps}
                                          selectRow={selectRow}
                                          defaultSorted={defaultSorted}
                                          classes={
                                            "table align-middle table-nowrap table-hover"
                                          }
                                          headerClasses="header-class is-sticky-hdr"
                                          id="tableScroll"
                                          bordered={true}
                                          // striped={true}
                                          responsive
                                        />
                                        {alert}
                                      </div>
                                    </Col>
                                  </Row>
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color="danger">
                {" "}
                You do not have access to this page.{" "}
              </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

AccessTypesList.propTypes = {
  permissions: PropTypes.array,
  onGetDepartments: PropTypes.func,
  onAddDepartment: PropTypes.func,
  onDeleteDepartment: PropTypes.func,
  onUpdateDepartment: PropTypes.func,
}

const mapStateToProps = ({ departments }) => ({
  permissions: departments.permissions,
  loading: departments.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetDepartments: () => dispatch(getDepartments()),
  onAddDepartment: department => dispatch(addDepartment(department)),
  onUpdateDepartment: department => dispatch(updateDepartment(department)),
  onDeleteDepartment: department => dispatch(deleteDepartment(department)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccessTypesList))
